var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SjGoods',{directives:[{name:"show",rawName:"v-show",value:(_vm.isJd==2),expression:"isJd==2"}],ref:"SjGoods"}),_c('JdGoods',{directives:[{name:"show",rawName:"v-show",value:(_vm.isJd==1),expression:"isJd==1"}],ref:"JdGoods"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }